import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { CheckCircle, Coffee, XCircle, Users, Palmtree, Stethoscope } from 'lucide-react';

export const StatusBadge = ({ status }) => {
  switch (status) {
    case 'clocked_in':
      return <Badge className="bg-green-500"><CheckCircle className="h-3 w-3 mr-1" />Arbeitet</Badge>;
    case 'on_break':
      return <Badge className="bg-amber-500"><Coffee className="h-3 w-3 mr-1" />Pause</Badge>;
    case 'clocked_out':
      return <Badge variant="secondary"><XCircle className="h-3 w-3 mr-1" />Beendet</Badge>;
    default:
      return <Badge variant="outline">Nicht da</Badge>;
  }
};

export const StatusCards = ({ statusCounts, absenceCounts }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
    <Card className="border-green-200 bg-green-50">
      <CardContent className="pt-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-green-600">Arbeitet</p>
            <p className="text-3xl font-bold text-green-700">{statusCounts.working}</p>
          </div>
          <CheckCircle className="h-8 w-8 text-green-500" />
        </div>
      </CardContent>
    </Card>
    <Card className="border-amber-200 bg-amber-50">
      <CardContent className="pt-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-amber-600">In Pause</p>
            <p className="text-3xl font-bold text-amber-700">{statusCounts.onBreak}</p>
          </div>
          <Coffee className="h-8 w-8 text-amber-500" />
        </div>
      </CardContent>
    </Card>
    <Card className="border-gray-200 bg-gray-50">
      <CardContent className="pt-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Beendet</p>
            <p className="text-3xl font-bold text-gray-700">{statusCounts.finished}</p>
          </div>
          <XCircle className="h-8 w-8 text-gray-400" />
        </div>
      </CardContent>
    </Card>
    <Card className="border-red-200 bg-red-50">
      <CardContent className="pt-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-red-600">Nicht da</p>
            <p className="text-3xl font-bold text-red-700">{statusCounts.notClocked}</p>
          </div>
          <Users className="h-8 w-8 text-red-400" />
        </div>
      </CardContent>
    </Card>
    {absenceCounts && (
      <Card className="border-sky-200 bg-sky-50" data-testid="absence-today-card">
        <CardContent className="pt-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-sky-700">Heute abwesend</p>
              <div className="flex items-baseline gap-2 mt-1">
                <span className="text-2xl font-bold text-sky-700" title="Urlaub">{absenceCounts.vacation}</span>
                <span className="text-stone-300">·</span>
                <span className="text-2xl font-bold text-orange-700" title="Krank">{absenceCounts.sick}</span>
                {absenceCounts.absenceOther > 0 && (
                  <>
                    <span className="text-stone-300">·</span>
                    <span className="text-2xl font-bold text-purple-700" title="Sonstige Abwesenheit">{absenceCounts.absenceOther}</span>
                  </>
                )}
              </div>
              <div className="flex items-center gap-2 mt-0.5 text-[10px] text-stone-500">
                <span className="flex items-center gap-1"><Palmtree className="h-3 w-3 text-sky-600" />Urlaub</span>
                <span className="flex items-center gap-1"><Stethoscope className="h-3 w-3 text-orange-600" />Krank</span>
              </div>
            </div>
            <Palmtree className="h-8 w-8 text-sky-400" />
          </div>
        </CardContent>
      </Card>
    )}
  </div>
);
